export default __webpack_public_path__ + "static/emp-icn7-031485ce140d474f8e22e0e8c8d07e47.png";